import { render, staticRenderFns } from "./AnimatedText.vue?vue&type=template&id=4c0d14a8&scoped=true&"
import script from "./AnimatedText.vue?vue&type=script&lang=js&"
export * from "./AnimatedText.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedText.vue?vue&type=style&index=0&id=4c0d14a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0d14a8",
  null
  
)

export default component.exports